import api from './api';

const cobranzasService = {
    // Obtener estado de cobranza del usuario actual
    getMyStatus: async () => {
        const response = await api.get('/api/cobranzas/my-status/');
        return response.data;
    },

    // Subir comprobante de pago
    uploadReceipt: async (file, notes = '') => {
        const formData = new FormData();
        formData.append('image', file);
        if (notes) {
            formData.append('notes', notes);
        }

        const response = await api.post('/api/cobranzas/upload-receipt/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    // Listar comprobantes (Gestor)
    getReceipts: async (params = {}) => {
        const response = await api.get('/api/cobranzas/receipts/', { params });
        return response.data;
    },

    // Aprobar o rechazar comprobante (Gestor)
    reviewReceipt: async (receiptId, action, reason = '') => {
        const response = await api.post(`/api/cobranzas/receipts/${receiptId}/review/`, {
            action,
            reason,
        });
        return response.data;
    },

    // Listar cuentas de cobranza (Gestor)
    getAccounts: async (params = {}) => {
        const response = await api.get('/api/cobranzas/accounts/', { params });
        return response.data;
    },

    // Actualizar configuración de una cuenta
    updateAccount: async (accountId, data) => {
        const response = await api.patch(`/api/cobranzas/accounts/${accountId}/`, data);
        return response.data;
    },

    // Estadísticas de cobranza
    getStats: async () => {
        const response = await api.get('/api/cobranzas/stats/');
        return response.data;
    },

    // Obtener configuración general (fechas, datos bancarios, imagen de pago)
    getConfig: async () => {
        const response = await api.get('/api/cobranzas/config/');
        return response.data;
    },

    // Actualizar configuración general
    updateConfig: async (formData) => {
        const isFormData = formData instanceof FormData;
        const response = await api.post('/api/cobranzas/config/', formData, {
            headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
        });
        return response.data;
    },

    // Cortar o reactivar manualmente el servicio del sistema (Interruptor Maestro)
    toggleBlock: async (block, reason = '') => {
        const response = await api.post('/api/cobranzas/toggle-block/', {
            block,
            reason,
        });
        return response.data;
    },

    // Helper para formatear URLs de media absolutas
    getMediaUrl: (url) => {
        if (!url) return '';
        const baseUrl = process.env.REACT_APP_FAST_FOOD_SERVICE || process.env.REACT_APP_API_BASE_URL || '';
        if (url.startsWith('http://backend:8000')) {
            return url.replace('http://backend:8000', baseUrl);
        }
        if (url.startsWith('/media/')) {
            return baseUrl ? `${baseUrl}${url}` : url;
        }
        return url;
    }
};

export default cobranzasService;
